import React, { Children } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/styles";

import OnBoardingSlide from "./OnBoardingSlide";
import OnBoardingHeader from "./OnBoardingHeader";
import OnBoardingFooter from "./OnBoardingFooter";
import OnBoardingOverlay from "./OnBoardingOverlay";
import useOnBoarding from "./useOnBoarding";

// isopen is written here in all lowercase to avoid a browser warning about the
// property not being recognized. It then needs to be a string or integer.
// This is only an issue in pre mui v5
const StyledOnboardingContainer = styled('div')(({ theme, isopen }) => ({
    display: isopen ? 'block' : 'none',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '44rem',
    background: 'white',
    zIndex: 12,
    borderRadius: '1.25rem',
    padding: '1.5rem 2rem',

    '& .onboarding-left-arrow, .onboarding-right-arrow': {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '2rem',
        cursor: 'pointer',
        color: '#d5d5d5',
        userSelect: 'none',
        '& i': {
            cursor: 'pointer',
        },
    },

    '& .onboarding-left-arrow': {
        left: '40px',
    },

    '& .onboarding-right-arrow': {
        right: '40px',
    },
}));

const OnBoardingContainer = ({ children, module, tag }) => {
    const childElements = Children.toArray(children);
    const childSlides = childElements.filter(item => item.type === OnBoardingSlide);
    const childCount = childSlides.length
    const headerComponent = childElements.filter(item => item.type === OnBoardingHeader);

    const {
        isOpen,
        currentSlide,
        setCurrentSlide,
        handleSkip,
        handleComplete,
        nextSlide,
        previousSlide,
    } = useOnBoarding({ module, tag, childCount });

    return (<>
        <OnBoardingOverlay isOpen={isOpen} />
        <StyledOnboardingContainer isopen={isOpen ? 1 : 0}>
            {headerComponent}

            {(currentSlide > 0 && childCount > 1) &&
                <div className="onboarding-left-arrow">
                    <i className="fa fa-arrow-circle-o-left"
                       aria-hidden="true"
                       onClick={previousSlide}
                    ></i>
                </div>
            }

            <div className="onboarding-slides-container">
                {childSlides.map((slide, index) => (
                    <React.Fragment key={index}>
                        {(index === currentSlide) && slide }
                    </React.Fragment>
                ))}
            </div>

            {currentSlide < (childCount - 1) && childCount > 1 &&
                <div className={'onboarding-right-arrow'}>
                    <i className="fa fa-arrow-circle-o-right"
                       aria-hidden="true"
                       onClick={nextSlide}
                    ></i>
                </div>
            }

            <OnBoardingFooter
                childCount={childCount}
                childSlides={childSlides}
                currentSlide={currentSlide}
                handleSkip={handleSkip}
                handleComplete={handleComplete}
                setCurrentSlide={setCurrentSlide}
            />
        </StyledOnboardingContainer>
    </>)
}

OnBoardingContainer.propTypes = {
    module: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
}

OnBoardingContainer.defaultProps = {
    module: null,
    tag: null,
}

export default OnBoardingContainer;
